define(['underscore'],
    function (_) {
        'use strict';

        return ['JsonRPCService', '$q', function (JsonRPCService, $q) {
            var bodyTypes, driveTypes, gearboxTypes, vehicleTypes, vehicleCategories;
            var loadingPromises;

            var loadBodyTypeMappings = function (callGroups) {
                if (!angular.isDefined(bodyTypes)) {
                    var promise = JsonRPCService.send('baslertypelistmapping', 'baslertypelistmapping', 'getBodyTypeMappings', [], callGroups);
                    promise.then(function(result) {
                            bodyTypes = result;
                        });
                    loadingPromises.push(promise);
                }
            };

            var loadDriveTypeMappings = function (callGroups) {
                if (!angular.isDefined(bodyTypes)) {
                    var promise = JsonRPCService.send('baslertypelistmapping', 'baslertypelistmapping', 'getDriveTypeMappings', [], callGroups);
                    promise.then(function(result) {
                            driveTypes = result;
                        });
                    loadingPromises.push(promise);
                }
            };

            var loadGearboxTypeMappings = function (callGroups) {
                if (!angular.isDefined(bodyTypes)) {
                    var promise = JsonRPCService.send('baslertypelistmapping', 'baslertypelistmapping', 'getGearboxTypeMappings', [], callGroups);
                    promise.then(function(result) {
                            gearboxTypes = result;
                        });
                    loadingPromises.push(promise);
                }
            };

            var loadVehicleTypeMappings = function (callGroups) {
                if (!angular.isDefined(bodyTypes)) {
                    var promise = JsonRPCService.send('baslertypelistmapping', 'baslertypelistmapping', 'getVehicleTypeMappings', [], callGroups);
                    promise.then(function(result) {
                            vehicleTypes = result;
                        });
                    loadingPromises.push(promise);
                }
            };

            var loadVehicleCategoryMappings = function (callGroups) {
                if (!angular.isDefined(bodyTypes)) {
                    var promise = JsonRPCService.send('baslertypelistmapping', 'baslertypelistmapping', 'getVehicleCategoryMappings', [], callGroups);
                    promise.then(function(result) {
                            vehicleCategories = result;
                    });
                    loadingPromises.push(promise);
                }
            };

            return {
                loadAllMappings: function () {
                    loadingPromises = [];

                    loadBodyTypeMappings('loadingMappings');
                    loadDriveTypeMappings('loadingMappings');
                    loadGearboxTypeMappings('loadingMappings');
                    loadVehicleTypeMappings('loadingMappings');
                    loadVehicleCategoryMappings('loadingMappings');

                    return $q.all(loadingPromises);
                },

                getBodyTypeByBaslerCode: function (baslerCode) {
                    return _.findWhere(bodyTypes, {baslerCode: baslerCode}).bodyType;
                },

                getDriveTypeByBaslerCode: function (baslerCode) {
                    return _.findWhere(driveTypes, {baslerCode: baslerCode}).driveType;
                },

                getGearboxTypeByBaslerCode: function (baslerCode) {
                    return _.findWhere(gearboxTypes, {baslerCode: baslerCode}).gearboxType;
                },

                getVehicleTypeByBaslerCode: function (baslerCode) {
                    return _.findWhere(vehicleTypes, {baslerCode: baslerCode}).vehicleType;
                },

                getVehicleCategoryByBaslerCode: function (baslerCode) {
                    return _.findWhere(vehicleCategories, {baslerCode: baslerCode}).vehicleCategory;
                }
            };
        }];
    });


// WEBPACK FOOTER //
// ../common/js/src/edge/policyjob/services/BaslerTypelistMappingService.js